import script from "./AdminCampaigns.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminCampaigns.vue?vue&type=script&setup=true&lang=js"

import "./AdminCampaigns.vue?vue&type=style&index=0&id=2e860218&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e860218"]])

export default __exports__